<template lang="pug">
  t-dialog(
    v-bind="$attrs"
    :value="isOpened"
    v-on="$listeners"
    :max-width="width"
    :showCloseBtn="!hideCloseButton"
    @input="close"
    :content-class="contentClass"
    :content-without-padding="removePadding"
    :close-button-props="closeButtonProps"
  )
    template(
      #title
      v-if="title"
    )
      p(
        class="ma-0 pa-0"
        :class="titleClass"
      ) {{ title }}
    template(
      #subtitle
      v-if="subtitle"
    )
      p(class="text-center ma-0 mt-2 pa-0") {{ subtitle }}
    template(#content)
      v-row(no-gutters)
        v-col(
          cols="12"
          v-if="text"
        )
          | {{ text }}
        v-col(
          cols="12"
          v-if="component"
        )
          component(
            :is="component"
            v-bind="{ ...componentProps, isOpened }"
            :closeModal="onCloseEvent"
            :changeDialogWidth="changeDialogWidth"
            v-on="componentListeners"
          )
    template(
      #actions
      v-if="showActions"
    )
      v-row(
        no-gutters
        justify="center"
      )
        v-col(
          cols="6"
          v-if="buttonText.approve"
        )
          v-btn(
            @click="confirm"
            class="main-button plain-error w-100"
          )
            | {{ buttonText.approve }}
        v-col(
          cols="6"
          v-if="buttonText.dismiss"
        )
          v-btn(
            @click="close"
            class="ml-4 main-button w-100"
          )
            | {{ buttonText.dismiss }}
</template>

<script>
import QrcodeVue from 'qrcode.vue'
import TOrmButtons from '~/components/templates/orm/t-orm-buttons'
import TDialog from '~/components/templates/t-dialog'
import Dialog from '~/models/system/Dialog'

// used components
// TODO this must be rethink
import MFormBlock from '~/components/modules/blocks/m-form-block'
import MOrmTable from '~/components/modules/tables/orm/m-orm-table'
import BlockNotificationsList from '~/modules/notifications/views/components/block-notifications-list'
import BlockSingleNotification from '~/modules/notifications/views/components/block-single-notification'
import MSupportButtons from '~/components/modules/m-support-buttons'
import FormOrganizationsUsersAdd from '~/modules/organizations/components/modules/forms/form-organizations-users-add.vue'
import FormOrganizationsUsersEdit from '~/modules/organizations/components/modules/forms/form-organizations-users-edit.vue'
import BlockDocumentsDownload from '~/modules/documents/components/blocks/block-documents-download'
import FormChangeName from '~/modules/profile/components/forms/form-change-name'
import BlockDocumentsSuccess from '~/modules/documents/components/blocks/block-documents-success'
import BlockOrganizationsSuccess from '~/modules/organizations/components/blocks/block-organizations-success.vue'
import MDocumentsSignStatus from '~/modules/documents/components/modules/m-documents-sign-status'
import MDocumentShare from '~/modules/documents/components/modules/m-document-share'
import MDocumentSharePro from '~/modules/documents/components/modules/m-document-share-pro'
import FormTag from '~/modules/tags/components/form-tag'
import BlockProfileApiKeysForm from '~/modules/profile/components/block-profile-api-keys-form'
import FormDocumentsMassShare from '~/modules/documents/components/forms/form-documents-mass-share'
import BlockOrganizationsDelete from '~/modules/organizations/components/blocks/block-organizations-delete.vue'
import MOrganizationExistsDialog from '~/modules/organizations/components/modules/m-organization-exists-dialog.vue'
import BlockTemplateShare from '~/modules/templates/components/blocks/block-template-share'
import MTemplateUpload from '~/modules/templates/components/modules/m-template-upload'
import BlockDocumentsMassShareResults from '~/modules/documents/components/blocks/block-documents-mass-share-results'
import FormDocumentRejectConfirm from '~/modules/documents/components/forms/pro-version/form-document-reject-confirm'
import FormDocumentApprovers from '~/modules/documents/components/forms/pro-version/form-document-approvers'
import FormFolders from '~/modules/documents/components/forms/pro-version/form-folders'
import MFoldersTreeview from '~/modules/documents/components/modules/pro-version/m-folders-treeview'
import MCreateContact from '~/modules/contacts/components/m-create-contact'
import MContactContent from '~/modules/contacts/components/m-contact-content'
import MCreateContactStatus from '~/modules/contacts/components/m-create-contact-status'
import MEditContact from '~/modules/contacts/components/m-edit-contact'
import MUploadContact from '~/modules/contacts/components/m-upload-contact'
import MCreateContactErrors from '~/modules/contacts/components/m-create-contact-errors'
import MDocumentCancel from '~/modules/documents/components/modules/m-document-cancel'
import MTrialAccessDialog from '~/components/modules/m-trial-access-dialog'
import MBlockWelcomePremium from '~/components/modules/blocks/concrete/m-block-welcome-premium'
import MAutofillData from '~/components/modules/m-autofill-data'
import BlockTemplatesAutocompletePreview from '~/modules/templates/components/blocks/block-templates-autocomplete-preview'
import BlockTemplatesAiFieldsGeneration from '~/modules/templates/components/blocks/block-templates-ai-fields-generation'
import BlockAiGenerationLoader from '~/modules/templates/components/blocks/block-ai-generation-loader'
import BlockAiFeedback from '~/modules/templates/components/blocks/block-ai-feedback'
import BlockTemplatesGalleryView from '~/modules/templates/components/blocks/block-templates-gallery-view'
import BillingPaymentForm from '~/modules/billing/components/billing-payment-form'
import BillingIndividualClientForm from '~/modules/billing/components/billing-individual-client-form'
import BillingPaymentStatus from '~/modules/billing/components/billing-payment-status'
import MBlockPremiumFeaturesStepper from '~/components/modules/blocks/concrete/m-block-premium-features-stepper'
import MBlockInputCopy from '~/components/modules/blocks/concrete/m-block-input-copy'
import MChangeEmail from '~/modules/profile/components/m-change-email'
import MDocumentDetails from '~/modules/documents/components/modules/admin/m-document-details'
import MUserDetails from '~/modules/users/components/modules/m-user-details'
import MOrganizationDetails from '~/modules/organizations/components/admin/m-organization-details'
import MTaxbillDetails from '~/modules/tax-bills/components/admin/m-taxbill-details'
import ProfileMonoCreateEdsKey from '~/modules/profile/components/profile-mono-create-eds-key'
import BlockIntegrationConnect from '~/modules/organizations/components/blocks/block-integration-connect'
import FormDocumentSendLater from '~/modules/documents/components/forms/pro-version/form-document-send-later'
import MDocumentSavedParticipantsRouteForm from '~/modules/documents/components/modules/pro-version/m-document-saved-participants-route-form'
import BlockRouteDetails from '~/modules/organizations/components/blocks/block-route-details'
import MBlockNewFeature from '~/components/modules/blocks/concrete/m-block-new-feature'
import FormOrganizationsOnSignCallback from '~/modules/organizations/components/modules/forms/form-organizations-on-sign-callback'
import FormTemplateSignerName from '~/modules/templates/components/modules/forms/form-template-signer-name'
import MDocumentsApiActionStatus from '~/modules/documents/components/modules/m-documents-api-action-status'
import FormOrganizationsUsersNotifications from '~/modules/organizations/components/modules/forms/form-organizations-users-notifications'
import BlockOrganizationSignPreview from '~/modules/organizations/components/blocks/block-organization-sign-preview'
import BlockTranzzoGenerateToken from '~/modules/tranzzo/components/block-tranzzo-generate-token'
import BillingGenerateActForm from '~/modules/billing/components/billing-generate-act-form'
import PaymentEditForm from '~/modules/admin/components/payment-edit-form'
import BillingActViewer from '~/modules/billing/components/billing-act-viewer'
import MBlockImageCropper from '~/components/modules/blocks/concrete/m-block-image-cropper'

export default {
  components: {
    TOrmButtons,
    TDialog,
    QrcodeVue,
    MFormBlock,
    MOrmTable,
    BlockNotificationsList,
    BlockSingleNotification,
    MSupportButtons,
    FormOrganizationsUsersAdd,
    FormOrganizationsUsersEdit,
    BlockDocumentsDownload,
    FormChangeName,
    BlockDocumentsSuccess,
    BlockOrganizationsSuccess,
    MOrganizationExistsDialog,
    MDocumentsSignStatus,
    MDocumentShare,
    MDocumentSharePro,
    FormTag,
    BlockProfileApiKeysForm,
    FormDocumentsMassShare,
    BlockOrganizationsDelete,
    BlockTemplateShare,
    BlockDocumentsMassShareResults,
    MTemplateUpload,
    FormDocumentRejectConfirm,
    FormDocumentApprovers,
    FormFolders,
    MFoldersTreeview,
    MCreateContact,
    MContactContent,
    MCreateContactStatus,
    MEditContact,
    MUploadContact,
    MCreateContactErrors,
    MDocumentCancel,
    MTrialAccessDialog,
    MBlockWelcomePremium,
    MAutofillData,
    BlockTemplatesAutocompletePreview,
    BlockTemplatesAiFieldsGeneration,
    BlockAiGenerationLoader,
    BlockAiFeedback,
    BlockTemplatesGalleryView,
    BillingPaymentForm,
    BillingIndividualClientForm,
    BillingPaymentStatus,
    MBlockPremiumFeaturesStepper,
    MBlockInputCopy,
    MChangeEmail,
    MDocumentDetails,
    MUserDetails,
    MOrganizationDetails,
    MTaxbillDetails,
    ProfileMonoCreateEdsKey,
    BlockIntegrationConnect,
    FormDocumentSendLater,
    MDocumentSavedParticipantsRouteForm,
    BlockRouteDetails,
    MBlockNewFeature,
    FormOrganizationsOnSignCallback,
    FormTemplateSignerName,
    MDocumentsApiActionStatus,
    FormOrganizationsUsersNotifications,
    BlockOrganizationSignPreview,
    BlockTranzzoGenerateToken,
    BillingGenerateActForm,
    PaymentEditForm,
    BillingActViewer,
    MBlockImageCropper
  },
  props: {
    type: {
      type: String,
      default: 'content'
    }
  },
  data: () => ({
    dialogWidth: null
  }),
  computed: {
    dialog() {
      return Dialog.query().where('type', this.type).first()
    },
    isOpened() {
      return this._.get(this.dialog, 'isOpened', false)
    },
    params() {
      return this._.get(this.dialog, 'params', '')
    },
    title() {
      const title = this._.get(this.params, 'title', '')
      return this._.isFunction(title) ? title(this) : this.$t(title)
    },
    subtitle() {
      const subtitle = this._.get(this.params, 'subtitle', '')
      return this._.isFunction(subtitle) ? subtitle(this) : this.$t(subtitle)
    },
    text() {
      const text = this._.get(this.params, 'text', '')
      return this._.isFunction(text) ? text(this) : this.$t(text)
    },
    hideCloseButton() {
      return this._.get(this.params, 'hideCloseButton', false)
    },
    showActions() {
      return this._.get(this.params, 'showActions', false)
    },
    component() {
      return this._.get(this.params, 'component')
    },
    componentProps() {
      return this._.get(this.params, 'componentProps')
    },
    componentListeners() {
      return this._.get(this.params, 'componentListeners')
    },
    buttonText() {
      return this._.get(this.params, 'buttonText')
    },
    width() {
      return this.dialogWidth || this._.get(this.params, 'width', '800px')
    },
    titleClass() {
      return this._.get(this.params, 'titleClass', 'text-center')
    },
    onClose() {
      return this._.get(this.params, 'onClose')
    },
    removePadding() {
      return this._.get(this.params, 'removePadding', false)
    },
    contentClass() {
      return this._.get(this.componentProps, 'contentClass', '')
    },
    closeButtonProps() {
      return this._.get(this.params, 'closeButtonProps', {})
    }
  },
  created() {
    if (!this.dialog) {
      Dialog.insert({
        data: {
          type: this.type
        }
      })
    }
  },
  methods: {
    changeDialogWidth(val) {
      this.dialogWidth = val
    },
    async close() {
      this.changeDialogWidth(null)
      if (this._.isFunction(this.onClose)) {
        await this.onClose()
      }
      await this.dialog.close(false, true)
    },
    confirm() {
      this.dialog.close(true, true)
    },
    onCloseEvent(payload, confirmed = true) {
      this.dialog.close(payload, confirmed)
    }
  }
}
</script>
